import { render } from "./TimetablePracticeCell.vue?vue&type=template&id=2a88883e&scoped=true"
import script from "./TimetablePracticeCell.vue?vue&type=script&lang=js"
export * from "./TimetablePracticeCell.vue?vue&type=script&lang=js"

import "./TimetablePracticeCell.vue?vue&type=style&index=0&id=2a88883e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a88883e"]])

export default __exports__